module.exports = `
  type Admin {
    access_token: String
    done: Boolean
  }
`;
